import { render, staticRenderFns } from "./BubbleMenu.vue?vue&type=template&id=403a6ca4"
import script from "./BubbleMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./BubbleMenu.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BubbleMenu.vue?vue&type=style&index=0&id=403a6ca4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports